import React from "react";
import "../styles/TeacherCommentBox.css"; // Include the styles

const TeacherCommentBox = ({ comments, isOpen, onClose, onRemoveVideo }) => {
  if (!isOpen) return null;
  console.log(comments);

  // Handler for the remove video button click
  const handleRemoveVideo = () => {
    if (onRemoveVideo) {
      onRemoveVideo();
    }
    onClose(); // Close the modal when video is removed
  };

  return (
    <div className="comment-modal-backdrop">
      <div className="comment-modal">
        <button className="comment-close-button" onClick={onClose}>
          ×
        </button>
        <h2>Comments</h2>

        <div className="comments-list">
          {/* Example comment */}
          <p>{comments}</p>
        </div>

        <button className="remove-video-button" onClick={handleRemoveVideo}>
          Remove Video
        </button>
      </div>
    </div>
  );
};

export default TeacherCommentBox;
